module.exports = __webpack_public_path__ + "img/RETURN_SALE.47998f5b.svg";